export const BLACK = "#181818";
export const GREY = "#4d4d4e";
export const PURPLE = "#b026ff";
export const LIGHTGREY = "#a6a6a6";
export const DARKGREY = "#1c1b1b";
export const WHITE = "#f5f5f5";
